// <s-background-video> — decorative looping background video with a visible pause/play control.
// Autoplay is skipped when the visitor prefers reduced motion; the --toggle command plays or pauses.
class SBackgroundVideo extends HTMLElement {
  #ac;
  #video;
  #button;

  connectedCallback() {
    this.#ac = new AbortController();
    this.#video = this.querySelector('video');
    this.#button = this.querySelector('[data-video-toggle]');
    if (!this.#video) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      this.#video.pause();
    } else {
      this.#video.play().catch(() => this.#sync());
    }

    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      if (this.#video.paused) {
        this.#video.play().catch(() => {});
      } else {
        this.#video.pause();
      }
    }, { signal: this.#ac.signal });

    this.#video.addEventListener('play', () => this.#sync(), { signal: this.#ac.signal });
    this.#video.addEventListener('pause', () => this.#sync(), { signal: this.#ac.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    if (!this.#button) return;
    const playing = !this.#video.paused;
    this.#button.setAttribute('aria-pressed', playing ? 'false' : 'true');
    this.#button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
    this.#button.querySelector('[data-icon-pause]')?.toggleAttribute('hidden', !playing);
    this.#button.querySelector('[data-icon-play]')?.toggleAttribute('hidden', playing);
  }
}

if (!customElements.get('s-background-video')) customElements.define('s-background-video', SBackgroundVideo);
